exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3uJ-H2kZQiNliBrVCZ9rJO+._3uJ-H2kZQiNliBrVCZ9rJO{margin-left:1.42857rem}._1uEiM8v56w_pQfZSVY4lIx{height:5.78571rem;max-width:50rem;width:100%}._1uEiM8v56w_pQfZSVY4lIx form{display:none;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}@media only screen and (min-width:480px){._1uEiM8v56w_pQfZSVY4lIx form{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}}._1ljQZyZK25cdVtVyjrcG7O{width:32%}._2zPuxHPYeF9s3dCbHjrGKm{font-weight:600;padding-bottom:.35714rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"TeacherTasks_inputSelect": "_3uJ-H2kZQiNliBrVCZ9rJO",
	"TeacherTasks_filters": "_1uEiM8v56w_pQfZSVY4lIx",
	"TeacherTasks_filters_field": "_1ljQZyZK25cdVtVyjrcG7O",
	"TeacherTasks_filters_field_label": "_2zPuxHPYeF9s3dCbHjrGKm"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/UserDashboard/TeacherTasks/style.postcss
// module id = 2041
// module chunks = 0